<div class="pending_patient_tooltip" style="min-width: 200px;" id="IdOfNetworkChartTooltip">
  <div class="pending_patient_header container py-2">
    <div class="d-flex justify-content-between align-items-center">
      <span class="pending_patient_header_heading">{{popupHeading}}</span>
      <mat-icon style="font-size: 15px;padding: 5px 5px;color: #fff;cursor: pointer;" (click)="hidePendingLinkTooltip()">close</mat-icon>
    </div>
    <div>
      <span class="pending_patient_header_data">{{PendingPatients}}</span>
    </div>
  </div>

  <div class="py-1">
    <div class="px-3 my-2 d-flex align-items-center justify-content-between" *ngFor="let item of toolTipData" style="gap: 10px;">
      <div class="d-flex align-items-center" style="min-width: 150px;gap: 5px;">
        <div class="tooltip_outlay" [style.background]="item.color ? item.color : 'red'"></div>
        <span class="pending_patient_body_data">{{item?.count ? isNumber(item?.count) ? this.numberPipe.transform(item.count) : item.count : 0}} {{item?.status == 'PATIENTS' ? '' : item?.status }}</span>
      </div>
      <div class="w-auto text-start" *ngFor="let data of popupConfig">
        <div class="pending_patient_body_data_text" >
          <a (click)="item?.value != 0 ? routeHandler(data, item) : ''" [style.cursor]="item?.value == 0 ? 'not-allowed': 'pointer'" name="Patients" style="cursor:pointer; color: #1363df;">{{data.disp_name}}</a>
        </div>
      </div>    
    </div>
  </div>
</div>